export const cardTitleStyles = {
  title: {
    display: "flex",
  },
  icon: {
    marginRight: "16px",
  },
  text: {
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "25px",
    color: "#103B66",
  },
};
